import React from "react";

/**
 * SpaceCardSkeleton - A loading placeholder that matches the structure of SpaceCard
 */
const SpaceCardSkeleton = () => {
  return (
    <div className="overflow-hidden bg-white rounded-lg border border-gray-200 shadow-sm">
      {/* Image Skeleton */}
      <div className="relative h-48 sm:h-56 bg-gray-200 animate-pulse" />

      {/* Content Skeleton */}
      <div className="p-2 sm:p-3 space-y-3">
        {/* Title */}
        <div className="h-5 w-3/4 bg-gray-200 animate-pulse rounded" />

        {/* Capacity & Icons row */}
        <div className="flex items-center gap-2">
          <div className="h-3.5 w-3.5 bg-gray-200 animate-pulse rounded-full" />
          <div className="h-3 w-24 bg-gray-200 animate-pulse rounded" />
        </div>

        {/* Location */}
        <div className="flex items-center gap-2">
          <div className="h-3.5 w-3.5 bg-gray-200 animate-pulse rounded-full" />
          <div className="h-3 w-full max-w-[180px] bg-gray-200 animate-pulse rounded" />
        </div>

        {/* Units / Availability row */}
        <div className="flex justify-between items-center py-1">
          <div className="flex items-center gap-2">
            <div className="h-3.5 w-3.5 bg-gray-200 animate-pulse rounded-full" />
            <div className="h-3 w-12 bg-gray-200 animate-pulse rounded" />
          </div>
          <div className="h-5 w-10 bg-gray-200 animate-pulse rounded-full" />
        </div>

        {/* Pricing Section */}
        <div className="pt-2 border-t space-y-3">
          <div className="flex justify-between items-center">
            <div className="h-3 w-16 bg-gray-200 animate-pulse rounded" />
            <div className="h-5 w-24 bg-gray-200 animate-pulse rounded" />
          </div>

          {/* Button Placeholder */}
          <div className="h-9 w-full bg-gray-200 animate-pulse rounded shadow-sm" />
        </div>
      </div>
    </div>
  );
};

export default SpaceCardSkeleton;
